<script>
import store from '@state/store'
import axios from 'axios'
import { DateTime } from 'luxon'

export default {
  components: {},
  data() {
    return {
      loaded: false,
      figment: null,
    }
  },
  mounted() {
    this.figment = store.getters['figments/selectedFigment']
    this.loaded = true
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' })
  },
  methods: {
    doCopy(field) {
      this.form.validateFields((_err, values) => {
        let text
        if (field === 'dob') {
          text = DateTime.fromISO(values[field]).toFormat('MMMM dd, yyyy')
        } else {
          text = values[field]
        }
        this.$copyText(text).then(
          () => {
            this.$notification.success({
              message: `Field Copied!`,
              duration: 2,
            })
          },
          () => {
            this.$notification.error({
              message: `Failed to Copy`,
              duration: 2,
            })
          }
        )
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.figment.meta.bio = {
            ...this.figment.meta.bio,
            firstName: values.firstName,
            lastName: values.lastName,
            dob: values.dob,
            birthplace: values.birthplace,
            currentLocation: values.currentLocation,
            active:
              values.active === undefined
                ? this.figment.meta.bio.active
                : values.active,
          }

          axios
            .put(
              process.env.VUE_APP_KONSUL_API_URL + '/figments',
              this.figment,
              {
                headers: {
                  Authorization: 'Bearer ' + this.$auth.user.access_token,
                },
              }
            )
            .then(
              (res) => {
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.name || 'Figment'
                  } Successfully Updated`,
                })
                store.commit('figments/SET_FIGMENT', this.figment)
              },
              () => {
                this.$notification.error({
                  message: 'Failed to Update Figment',
                })
              }
            )
        } else {
          this.$notification.error({
            message: 'Please correct the errors in your form!',
          })
        }
      })
    },
  },
}
</script>

<template>
  <div class="bio--container">
    <div v-if="!loaded" class="loader">
      <a-icon
        type="loading"
        style="padding-left: 8px; font-size: 24px; color: #1890ff"
        spin
      />
    </div>
    <div v-else>
      <a-form :form="form" @submit="handleSubmit">
        <a-card style="width: 100%">
          <a-row :gutter="16">
            <a-col :sm="12">
              <a-form-item label="First Name">
                <a-button
                  size="small"
                  shape="circle"
                  @click="doCopy('firstName')"
                >
                  <a-icon type="copy" />
                </a-button>
                <a-input
                  v-decorator="[
                    'firstName',
                    {
                      initialValue: figment.meta.bio.firstName,
                      rules: [
                        {
                          required: true,
                          placeholder: 'Please input your firstName!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :sm="12">
              <a-form-item label="Last Name">
                <a-button
                  size="small"
                  shape="circle"
                  @click="doCopy('lastName')"
                >
                  <a-icon type="copy" />
                </a-button>
                <a-input
                  v-decorator="[
                    'lastName',
                    {
                      initialValue: figment.meta.bio.lastName,
                      rules: [
                        {
                          required: true,
                          placeholder: 'Please input your lastName!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :sm="12">
              <a-form-item label="Current Location">
                <a-button
                  size="small"
                  shape="circle"
                  @click="doCopy('currentLocation')"
                >
                  <a-icon type="copy" />
                </a-button>
                <a-input
                  v-decorator="[
                    'currentLocation',
                    {
                      initialValue: figment.meta.bio.currentLocation,
                      rules: [
                        {
                          required: true,
                          placeholder: 'Please input your current location!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :sm="12">
              <a-form-item label="Birthplace">
                <a-button
                  size="small"
                  shape="circle"
                  @click="doCopy('birthplace')"
                >
                  <a-icon type="copy" />
                </a-button>
                <a-input
                  v-decorator="[
                    'birthplace',
                    {
                      initialValue: figment.meta.bio.birthplace,
                      rules: [
                        {
                          required: true,
                          placeholder: 'Please input your birthplace!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :sm="12">
              <a-form-item label="Date of Birth">
                <a-button size="small" shape="circle" @click="doCopy('dob')">
                  <a-icon type="copy" />
                </a-button>
                <a-date-picker
                  v-decorator="[
                    'dob',
                    {
                      initialValue: figment.meta.bio.dob,
                      rules: [
                        {
                          type: 'any',
                          required: true,
                          placeholder: 'Please input your dob!',
                        },
                      ],
                    },
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :sm="12">
              <a-form-item label="Is Active">
                <a-switch
                  v-decorator="[
                    'active',
                    {
                      initialValue: figment.meta.bio.active,
                      valuePropName: 'checked',
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row class="submit--container">
            <a-col :sm="16" :md="8">
              <a-form-item>
                <a-button type="primary" html-type="submit"> Save </a-button>
              </a-form-item>
            </a-col>
            <a-col :sm="16" :md="3">
              <a-form-item>
                <a-button @click="$router.go(-1)"> Cancel </a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
      </a-form>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.loader {
  padding: 2rem;
  text-align: center;
}

.button--container {
  width: 100%;
  margin-top: 8px;

  button {
    width: 100%;
  }
}

.form--container {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: white;
}

.bio--container {
  height: 100%;
  overflow-y: scroll;
  button.ant-btn.ant-btn-circle.ant-btn-sm {
    position: absolute;
    top: -41px;
    right: 0;
    z-index: 1;
  }
}
</style>
